import { Routes } from '@angular/router';
import { OrganizationList } from './components/organization-list/organization-list';
import { authGuard } from './auth.guard';
import { adminGuard } from './admin.guard';
import { homeRedirectGuard } from './home-redirect.guard';

export const routes: Routes = [
  // The landing page depends on the user, so the guard resolves the destination
  {
    path: '',
    pathMatch: 'full',
    canActivate: [authGuard, homeRedirectGuard],
    children: [],
  },
  // Organization list
  {
    path: 'organization-list',
    canActivate: [authGuard],
    component: OrganizationList,
  },
  // Create / Edit organization
  {
    path: 'create-edit-organization',
    canActivate: [authGuard],
    loadChildren: () => import('./create-edit-organization/create-edit-organization.module').then(m => m.CreateEditOrganizationModule),
  },
  // Claim ownership list
  {
    path: 'ownership-claim-list',
    canActivate: [authGuard, adminGuard],
    loadChildren: () => import('./components/ownership-claim-list/ownership-claim-list.module').then(m => m.OwnershipClaimListModule),
  },
];
